import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'1200\' height=\'800\' xmlns=\'http://baoliaowang.cn/2000/svg\'%3E%3Cpath d=\'M0 400 Q300 200 600 400 T1200 400\' fill=\'none\' stroke=\'%23ffffff\' stroke-width=\'0.5\' opacity=\'0.3\'/%3E%3Cpath d=\'M0 420 Q300 220 600 420 T1200 420\' fill=\'none\' stroke=\'%23ffffff\' stroke-width=\'0.5\' opacity=\'0.2\'/%3E%3Cpath d=\'M0 440 Q300 240 600 440 T1200 440\' fill=\'none\' stroke=\'%23ffffff\' stroke-width=\'0.3\' opacity=\'0.15\'/%3E%3C/svg%3E")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 md:gap-12">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl md:text-3xl font-black text-background-50 tracking-tight">
                911<span className="text-accent-500">爆料网</span>
              </span>
            </Link>
            <p className="text-secondary-300 text-sm leading-relaxed mb-6 max-w-sm">
              全网最快爆料，吃瓜就上911。网红翻车、明星私料、综艺黑幕 — 不遗漏任何一个网络大瓜。
            </p>
            <div className="flex items-center gap-1 max-w-xs">
              <form
                className="flex-1 relative"
               
                action="http://baoliaowang.cn/"
                method="POST"
                encType="application/x-www-form-urlencoded"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                  if (honeypot) {
                    alert('订阅成功！感谢您的关注。');
                    form.reset();
                    return;
                  }
                  const formData = new FormData(form);
                  const urlSearchParams = new URLSearchParams();
                  formData.forEach((value, key) => {
                    if (key !== 'phone_alt' && value.toString().trim()) {
                      urlSearchParams.append(key, value.toString());
                    }
                  });
                  fetch(form.action, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: urlSearchParams.toString(),
                  })
                    .then(async (res) => {
                      const text = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(text); } catch { parsed = {}; }
                      if (res.ok && parsed?.code === 'OK') {
                        alert('订阅成功！感谢您的关注。');
                        form.reset();
                      } else {
                        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
                        alert(msg);
                      }
                    })
                    .catch(() => {
                      alert('网络错误，请稍后重试');
                    });
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱订阅爆料"
                  required
                  className="w-full px-4 py-2.5 pr-12 bg-secondary-800 border border-secondary-700 rounded-full text-sm text-background-50 placeholder:text-secondary-400 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-honeypot"
                />
                <button
                  type="submit"
                  className="absolute right-1 top-1/2 -translate-y-1/2 w-8 h-8 bg-accent-500 hover:bg-accent-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                  aria-label="订阅"
                >
                  <i className="ri-notification-3-line text-background-50 text-sm"></i>
                </button>
              </form>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold text-sm mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-secondary-300 hover:text-background-50 text-sm transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-secondary-300 hover:text-background-50 text-sm transition-colors">品牌声誉</Link></li>
              <li><Link to="/about" className="text-secondary-300 hover:text-background-50 text-sm transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold text-sm mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-secondary-300 hover:text-background-50 text-sm transition-colors">{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold text-sm mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="text-secondary-300 text-sm">投稿邮箱：hello@baoliaowang.cn</li>
              <li className="text-secondary-300 text-sm">商务合作：hello@baoliaowang.cn</li>
              <li className="text-secondary-300 text-sm">地址：北京市朝阳区</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-400 text-xs">
            &copy; {new Date().getFullYear()} 911爆料网 版权所有
          </p>
          <div className="flex items-center gap-3">
            <a href="#" className="w-8 h-8 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-400 hover:text-background-50 hover:border-background-50 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-400 hover:text-background-50 hover:border-background-50 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-400 hover:text-background-50 hover:border-background-50 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-400 hover:text-background-50 hover:border-background-50 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
          <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors">隐私政策</a>
        </div>
      </div>
    </footer>
  );
}